import {createSlice} from "@reduxjs/toolkit"
import {loadWorkspace} from "./workspaceSlice"
import {noteArticleTabsV2} from "./noteArticleTabsV2Slice"

export const DYNAMIC_PANEL_TAB_INDEX_MAP = {
	ARTICLE_SEARCH: 0,
	NOTE_ARTICLE_LIST: 1,
	TOOLS: 2,
	AUTOMATED_SEARCH: 3,
	NOTIFICATION: 4,
	NON_PUBMED_IMPORT: 5
	// ### PortalLegacy ### \\
	//PORTALS: 4,
	// ### PortalLegacy ### \\
}

const initialValue = DYNAMIC_PANEL_TAB_INDEX_MAP["ARTICLE_SEARCH"]

export const dynamicViewSlice = createSlice({
	name: "dynamicView",
	initialState: {
		byWorkspace: {}
	},
	reducers: {
		setDynamicView: (state, action) => {
			const {newValue, workspaceId} = action.payload
			state.byWorkspace[workspaceId] = newValue
		},
	},
	extraReducers: builder => {
		builder.addCase(noteArticleTabsV2.actions.handleNoteArticle, (state, action) => {
			const {workspaceId} = action.payload.note
			state.byWorkspace[workspaceId] = DYNAMIC_PANEL_TAB_INDEX_MAP.NOTE_ARTICLE_LIST
		})
		builder.addCase(loadWorkspace.fulfilled, (state, action) => {
			state.byWorkspace[action.meta.arg] = initialValue
		})
	}
})

export const { setDynamicView } = dynamicViewSlice.actions

export const selectDynamicView = (state, workspaceId) => state.dynamicView.byWorkspace[workspaceId] ?? initialValue

export default dynamicViewSlice.reducer
